var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPopoverArrowUp = function SvgPopoverArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.678 1.415a4 4 0 0 1 4.357 0L27.713 9H0l11.678-7.585Z",
    fill: "currentColor"
  })));
};

export { SvgPopoverArrowUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDI4IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMS42Nzc2IDEuNDE1MThDMTMuMDAyNiAwLjU1NDUzNCAxNC43MTAyIDAuNTU0NTMzIDE2LjAzNTIgMS40MTUxOEwyNy43MTI4IDlIMEwxMS42Nzc2IDEuNDE1MThaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";